import { membershipQueries } from "@app/config/queryFactory";
import { AsyncBoundary } from "@base/ui/AsyncBoundary";
import { myinfoQueries } from "@features/myinfo/api/queryFactory";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Credits from "./Credits";
import { ReservationDatePicker } from "./ReservationDatePicker";
import { ReservationItem } from "./ReservationItem";

const Reservations = () => {
  const { t } = useTranslation();

  const [selectedDate, setSelectedDate] = useState(new Date());

  const year = selectedDate.getFullYear();
  const month = selectedDate.getMonth() + 1;

  const { data: membership } = useQuery(membershipQueries.membership());
  const { data } = useQuery({
    ...myinfoQueries.reservations(year, month),
    enabled: !!membership,
  });

  const reservations = data?.reservations ?? [];

  // 미팅룸 크레딧은 SILVER 멤버십만 이용 가능
  const isMeetingRoomEligible = membership?.plan_description?.type === "SILVER";

  return (
    <div className="space-y-8 md:space-y-10">
      {isMeetingRoomEligible && (
        <section className="space-y-2">
          <h2 className="text-title4 tracking-[-0.48px] text-gray-1000">{t("credits")}</h2>
          <AsyncBoundary>
            <Credits />
          </AsyncBoundary>
        </section>
      )}
      <section>
        <div className="flex flex-col gap-6 md:justify-between md:flex-row md:items-center md:gap-2">
          <h2 className="text-title4 tracking-[-0.48px] text-gray-1000">{t("myReservations")}</h2>
          <ReservationDatePicker value={selectedDate} onValueChange={setSelectedDate} />
        </div>
        <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-2">
          {reservations.length === 0 ? (
            <p className="col-span-full py-12 text-center text-gray-500 text-body2">{t("noReservations")}</p>
          ) : (
            reservations.map((reservation) => <ReservationItem key={reservation.id} {...reservation} />)
          )}
        </div>
      </section>
    </div>
  );
};

export default Reservations;
